import { typeProducts } from "./products"
import { queryAlgoliaProductFacets } from "./queries/queryAlgoliaProductFacets"
import { queryAlgoliaProductSearch } from "./queries/queryAlgoliaProductSearch"
import { queryProduct } from "./queries/queryProduct"
import { queryProductCategories } from "./queries/queryProductCategories"
import { queryProductCategory } from "./queries/queryProductCategory"
import { queryProductSearch } from "./queries/queryProductSearch"
import { queryProducts } from "./queries/queryProducts"

const productSchema = {
  types: [typeProducts],
  resolvers: {
    Query: {
      ...queryProduct,
      ...queryProducts,
      ...queryProductCategories,
      ...queryProductCategory,
      ...queryProductSearch,
      ...queryAlgoliaProductSearch,
      ...queryAlgoliaProductFacets,
    },
    Mutation: {},
  },
}

export default productSchema
